import React, {Component} from 'react';
import { Provider } from 'react-redux';
// import { BrowserRouter } from "react-router-dom";
import { ConnectedRouter } from 'connected-react-router';
// import messages_es from "./translations/es.json";
import App from './components/App';
import Helmet from 'react-helmet';

document.addEventListener("DOMContentLoaded", () => {
  const preloader = document.getElementById("div-loader-bundle");
  if (preloader) {
    preloader.style.display = "none";
  }
})

class AppMain extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {store, history, eventReceive} = this.props;

    return (
      <>
        <Helmet>
          <meta http-equiv="Expires" content="0" />
          <meta http-equiv="Last-Modified" content="0" />
          <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
          <meta http-equiv="Pragma" content="no-cache" />
        </Helmet>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
      </>
    )
  }
}

export default AppMain;
